// Mock module to replace react-hot-loader for Vite compatibility
const noop = () => {};
const identity = (x) => x;

export const hot = (module) => (component) => component;
export const cold = (component) => component;
export const register = noop;
export const AppContainer = ({ children }) => children;
export const setConfig = noop;
export const areComponentsEqual = (a, b) => a === b;

const reactHotLoader = {
  hot,
  cold,
  register,
  AppContainer,
  setConfig,
  areComponentsEqual
};

// Make it available globally for packages that expect it
if (typeof window !== 'undefined') {
  window.reactHotLoader = reactHotLoader;
}

export default reactHotLoader;
